// extracted by mini-css-extract-plugin
export default {"leftside":"SignupOrLogin_leftside__P2XbO","anchortag":"SignupOrLogin_anchortag__56qrS"};